import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const createKnowledgeSource = () => ({
  id: `ks_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
  name: "",
  source: "",
});

const AgentKnowledgeSourcesSection = ({ knowledgeSources = [], onChange }) => {
  const hasKnowledgeSources = Array.isArray(knowledgeSources) && knowledgeSources.length > 0;
  const updateAt = (index, patch) => {
    const next = knowledgeSources.map((item, idx) => (idx === index ? { ...item, ...patch } : item));
    onChange(next);
  };

  const removeAt = (index) => onChange(knowledgeSources.filter((_, idx) => idx !== index));

  const addKnowledgeSource = () => onChange([...(knowledgeSources || []), createKnowledgeSource()]);

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6">Knowledge sources</Typography>
          {hasKnowledgeSources ? (
            <Button size="small" variant="outlined" onClick={addKnowledgeSource}>
              Add knowledge source
            </Button>
          ) : null}
        </Box>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          Add docs, URLs, or notes the agent should reference.
        </Typography>
        {!hasKnowledgeSources ? (
          <Paper variant="outlined" style={{ padding: 12 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="body1">+ Add a knowledge source...</Typography>
              <Button size="small" variant="outlined" onClick={addKnowledgeSource}>
                + Add knowledge source
              </Button>
            </Box>
          </Paper>
        ) : (
          (knowledgeSources || []).map((item, index) => (
            <Grid container spacing={1} key={item.id || index} style={{ marginBottom: 8 }}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Name"
                  value={item.name || ""}
                  onChange={(event) => updateAt(index, { name: event.target.value })}
                  placeholder="Policy handbook"
                />
              </Grid>
              <Grid item xs={12} md={7}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="URL or content"
                  value={item.source || ""}
                  onChange={(event) => updateAt(index, { source: event.target.value })}
                  placeholder="https://... or a short text note"
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <IconButton onClick={() => removeAt(index)}>
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))
        )}
      </CardContent>
    </Card>
  );
};

export default AgentKnowledgeSourcesSection;
